import React from "react";
import PropTypes from "prop-types";
import styles from "./FlexContainer.module.css";

const FlexContainer = (props) => {
  return (
    <div
      className={styles.flexContainer}
      style={{
        ...props.style,
        ...(props.directionIsRow && {
          flexDirection: "row",
          gap: "5px",
          border: "0",
        }),
        ...(props.width && {
          width: props.width,
          minWidth: props.width,
          maxWidth: props.width,
        }),
        ...(props.height && {
          height: props.height,
          minHeight: props.height,
          maxHeight: props.height,
        }),
        ...(props.isChild && { border: "0", padding: "0px" }),
      }}
    >
      {props.children}
    </div>
  );
};

FlexContainer.defaultProps = {
  directionIsRow: false,
  isChild: false,
};

FlexContainer.propTypes = {
  directionIsRow: PropTypes.bool,
  flexDirection: PropTypes.string,
  style: PropTypes.any,
  width: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isChild: PropTypes.bool,
};

export default FlexContainer;
